<!--
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-02-22 14:37:43
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2022-08-12 11:11:02
-->
<template>
	<div>
		<el-dialog :title="`分配${zsName}`" width="25%" show-close :visible.sync="distribution" @close="resetFrom('disFrom')">
			<template slot="title">
				<p>
					<span>分配{{ zsName }}</span>
					<span class="fz-14 yx-color-text-regular ml-6">{{ '(共' + total + '个商品)' }}</span>
				</p>
			</template>
			<el-form :model="disFrom" ref="disFrom" :rules="disRules">
				<el-form-item :label="zsName" label-width="100px" prop="userId">
					<zs-partner-select v-model="disFrom.userId" :apiType="1"></zs-partner-select>
				</el-form-item>
			</el-form>
			<div class="right">
				<p class="yx-color-primary pointer" @click="skipFun">找不到{{ zsName }}？建立新的{{ zsName }}账号</p>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="distribution = false">取 消</el-button>
				<el-button type="primary" @click="checkRule">确 定</el-button>
			</div>
		</el-dialog>
		<collision-reminder ref="collisionReminder" @submit="sumbit" />
	</div>
</template>
<script>
import { trusteeshipDistribution, getNewShopUser } from '@/api/shopManage';
import ZsPartnerSelect from '@/components/zsPartnerSelect';
import { zsRoleType, PLATFORM_DY } from '@/utils/dataMap';
import { getProductConfig } from '@/api/settings.js';
import collisionReminder from '@/components/business/collisionReminder/collisionReminder.vue';
export default {
	props: {
		platformId: {
			type: [Number, String],
			default: PLATFORM_DY.value,
		},
	},
	data() {
		return {
			distribution: false,
			imgUrl: 'https://cdn.chaoyongbushou.com/wx/20211108/1636372139805-c010edeb4a822302594d57f1bb6687c.png',
			disFrom: {
				userId: '',
			},
			disRules: {
				userId: [{ required: true, message: '请选择达人', target: 'blur' }],
			},
			operatingArr: [],
			params: {
				productIds: '',
				userId: '',
			},
			total: 1,
			list: [],
			productDuplicateAloneState: false,
			getNewShopUserState: 0,
		};
	},
	computed: {
		zsName() {
			return zsRoleType.name;
		},
	},
	methods: {
		async disInit(row) {
			this.params = {
				productIds: '',
				userId: '',
			};
			if (Array.isArray(row)) {
				if (!row.length) {
					this.$message.warning('请选择商品');
					return;
				}
				this.list = row;
				this.params.productIds = row.map(item => item.product_id);
				this.total = row.length;
			} else {
				this.list = [row];
				this.params.productIds = [row.product_id];
				this.total = 1;
			}
			this.distribution = true;
			this.getConfig();
		},
		async getConfig() {
			const { data, code } = await getProductConfig({ platformId: this.platformId });
			if (code === 0) {
				this.productDuplicateAloneState = data.productDuplicateAlone;
			}
		},
		// 判断选择的商品是否有跟进人
		async formatFollow() {
			const { code, data } = await getNewShopUser({
				shopUserList: this.list.map(val => {
					return {
						shopId: val.shop_id,
						userId: this.disFrom.userId,
					};
				}),
				platformId: this.platformId,
			});
			if (code === 0) {
				return data.canAllocate;
			}
		},
		checkRule() {
			this.$refs.disFrom.validate(async valid => {
				if (valid) {
					this.getNewShopUserState = (await this.formatFollow()) || 0;
					if (!this.productDuplicateAloneState) {
						this.Confirm();
						return;
					}
					if (this.productDuplicateAloneState && this.getNewShopUserState) {
						this.Confirm();
						return;
					}
					this.$refs.collisionReminder.show(this.list, this.disFrom.userId);
				}
			});
		},
		sumbit(obj) {
			this.params.productIds = obj.product_ids ? obj.product_ids.split(',') : [];
			this.params.shopDuplicateType = obj.radioValue;
			this.Confirm();
		},
		async Confirm() {
			this.params.userId = this.disFrom.userId;
			this.params.platformId = this.platformId;
			const { code } = await trusteeshipDistribution(this.params);
			if (code == 0) {
				this.$message.success('分配成功');
				this.$emit('refreshList');
				this.distribution = false;
				this.productDuplicateAloneState && !this.getNewShopUserState && this.$refs.collisionReminder.handleClose();
			}
		},
		skipFun() {
			this.$router.push({
				path: '/teamManage/subAccount',
			});
		},
		resetFrom(from) {
			this.$refs[from].resetFields();
		},
	},
	components: {
		ZsPartnerSelect,
		collisionReminder,
	},
};
</script>
<style lang="less" scoped>
/deep/ .el-select--small {
	width: 100%;
}
.right {
	text-align: right;
}
</style>
